import GeneralCompetencyEventListPageActionTypes from './general-competency-event-list-page-action-types';
import axios from 'axios';
import ValidationError from '../../../utils/validation-error';
import { ROLE_PERMISSIONS as Permissions } from '../../../resources/rolePermissions';
import { sortingToStringWithSubstitutes } from '../../../utils/objectUtils';
import { GENERAL_COMPETENCY_EVENT_STATUSES } from '../../../resources/generalCompetencyEventStatus';

export const loadGeneralCompetencyEventListPage = () => async(dispatch) => {
  dispatch(findGeneralCompetencyEvents());
};

export const findGeneralCompetencyEvents = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: GeneralCompetencyEventListPageActionTypes.LOAD_GENERAL_COMPETENCY_EVENT_LIST_START });
  const state = getState().generalCompetencyEventListPage;
  const query = {
    skip: payload ? payload.skip : state.skip,
    limit: payload ? payload.take : state.take,
    keyword: state.filter?.keyword,
    status: state.filter?.status?.id,
    sorting: sortingToStringWithSubstitutes(state.sorting, [
      { originalName: 'name', substituteName: 'Name' },
      { originalName: 'startDate', substituteName: 'StartDate' },
      { originalName: 'endDate', substituteName: 'EndDate' }
    ])
  };
  try {
    state.cancelToken?.cancel();
    state.cancelToken = axios.CancelToken.source();
    const result = await api.get(`api/general_competency_events`, query, state.cancelToken.token);
    const canWrite = getState().app.userPermissions.includes(Permissions.GENERAL_COMPETENCY_EVENTS_WRITE);
    const events = result ? result.data.map(e => ({
      ...e,
      startDate: e.startDate ? new Date(e.startDate) : null,
      endDate: e.endDate ? new Date(e.endDate) : null
    })) : [];
    dispatch({
      type: GeneralCompetencyEventListPageActionTypes.LOAD_GENERAL_COMPETENCY_EVENT_LIST_END,
      payload: {
        generalCompetencyEvents: events,
        total: result ? result.total : 0,
        skip: payload ? payload.skip : state.skip,
        take: payload ? payload.take : state.take,
        canWrite
      }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: GeneralCompetencyEventListPageActionTypes.LOAD_GENERAL_COMPETENCY_EVENT_LIST_END });
      throw error;
    }
  }
};

export const filterGeneralCompetencyEvents = (payload) => (dispatch) => {
  dispatch({
    type: GeneralCompetencyEventListPageActionTypes.FILTER_GENERAL_COMPETENCY_EVENT_LIST,
    payload: payload
  });
  dispatch(findGeneralCompetencyEvents());
};

export const clearGeneralCompetencyEventsFilter = () => (dispatch) => {
  dispatch({
    type: GeneralCompetencyEventListPageActionTypes.FILTER_GENERAL_COMPETENCY_EVENT_LIST,
    payload: {}
  });
  dispatch(findGeneralCompetencyEvents());
};

export const sortGeneralCompetencyEvents = (payload) => (dispatch) => {
  dispatch({
    type: GeneralCompetencyEventListPageActionTypes.SORT_GENERAL_COMPETENCY_EVENT_LIST,
    payload: payload
  });
  dispatch(findGeneralCompetencyEvents());
};

export const openGeneralCompetencyEventConfirmDialog = (payload) => async(dispatch) => {
  dispatch({
    type: GeneralCompetencyEventListPageActionTypes.TOGGLE_GENERAL_COMPETENCY_EVENT_LIST_CONFIRM_DIALOG,
    payload: payload
  });
};

export const closeGeneralCompetencyEventConfirmDialog = () => async(dispatch) => {
  dispatch({ type: GeneralCompetencyEventListPageActionTypes.TOGGLE_GENERAL_COMPETENCY_EVENT_LIST_CONFIRM_DIALOG });
};

export const loadGeneralCompetencyEventStatuses = (localizationService) => async(dispatch) => {
  const statuses = Object.keys(GENERAL_COMPETENCY_EVENT_STATUSES)
    .map(key => ({
      id: GENERAL_COMPETENCY_EVENT_STATUSES[key],
      name: localizationService.toLanguageString('generalCompetencyEvent.status' + GENERAL_COMPETENCY_EVENT_STATUSES[key])
    }));
  dispatch({
    type: GeneralCompetencyEventListPageActionTypes.LOAD_GENERAL_COMPETENCY_EVENT_LIST_STATUSES,
    payload: { statuses }
  });
};

export const removeGeneralCompetencyEventConfirmDialog = (payload) => async(dispatch, getState, { api }) => {
  const state = getState().generalCompetencyEventListPage;
  if (state.selectedEventId > 0) {
    try {
      await api.remove(`api/general_competency_events/${state.selectedEventId}`);
      dispatch(loadGeneralCompetencyEventListPage());
      dispatch({ type: GeneralCompetencyEventListPageActionTypes.TOGGLE_GENERAL_COMPETENCY_EVENT_LIST_CONFIRM_DIALOG });
    } catch (error) {
      if (error instanceof ValidationError) {
        dispatch({ type: GeneralCompetencyEventListPageActionTypes.SET_CONFIRM_DIALOG_ERROR, payload: { errorMessage: error.message } });
      }
    }
  } else {
    dispatch({ type: GeneralCompetencyEventListPageActionTypes.TOGGLE_GENERAL_COMPETENCY_EVENT_LIST_CONFIRM_DIALOG });
  }
};
